var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectedProfileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bxs:user"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.57031 5.41699C6.57031 7.48449 8.25281 9.16699 10.3203 9.16699C12.3878 9.16699 14.0703 7.48449 14.0703 5.41699C14.0703 3.34949 12.3878 1.66699 10.3203 1.66699C8.25281 1.66699 6.57031 3.34949 6.57031 5.41699ZM16.987 17.5003H17.8203V16.667C17.8203 13.4512 15.2028 10.8337 11.987 10.8337H8.65365C5.43698 10.8337 2.82031 13.4512 2.82031 16.667V17.5003H16.987Z",
    fill: "url(#paint0_linear_704_95)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_704_95",
    x1: 10.3203,
    y1: 1.66699,
    x2: 10.3203,
    y2: 17.5003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4056DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3746A3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedProfileIcon);
export default __webpack_public_path__ + "static/media/selectedProfileIcon.a5c7aae1ffbe0bda648ba56a151c0d5d.svg";
export { ForwardRef as ReactComponent };